import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import React from "react";
import { useTranslation } from "react-i18next";
import { View, Text } from "react-native";
import { useBalance } from "wagmi";

import { checkIcon } from "@/utils/transactions/ExchangeCurrencies";

export default function AssetSelected() {
  const { t } = useTranslation();
  const { primaryWallet, network } = useDynamicContext();

  const { data } = useBalance({
    address: primaryWallet?.address as `0x${string}`,
    chainId: network as number,
  });

  return (
    <View className="flex-row gap-2 items-center bg-gray border border-midgray rounded-md p-2">
      {data && primaryWallet && (
        <>
          <Text className="text-xl font-normal">
            {t("home/web3/transfer:assetselected")}
          </Text>
          <View className="flex-row items-center gap-1">
            {checkIcon(data?.symbol, 28)}
            <Text className="text-base">{data?.symbol}</Text>
          </View>
        </>
      )}
    </View>
  );
}
